var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:([_vm.styleWrap,{'border-radius':_vm.borderRadius}]),attrs:{"id":"cc-progress"}},[_c('div',{staticClass:"progress-color",style:(_vm.progressStyle)},[(_vm.showProgressCount)?_c('span',{staticClass:"progress-text-count",style:({
        left:((_vm.cpmLeft(_vm.num)) + "rem")
      })},[_vm._v(_vm._s(_vm.num)+"%")]):_vm._e()])])}
var staticRenderFns = []

export { render, staticRenderFns }